<template>
  <base-modal-center
    :isFooter="true"
    ref="shareMyAdvisorModal"
    title="Compartilhe seu site"
  >
    <template #btn-close-icon>
      <i class="icon">
        <base-icon name="painel/close-icon" />
      </i>
    </template>
    <div class="modal-share-wedsite has-text-centered c-modal">
      <div class="c-modal-top columns">
        <div
          class="column is-12 is-8-desktop is-flex is-justify-content-center is-align-items-center"
        >
          <h6 class="c-base-modal__title">
            Indique
            <strong v-if="hasShowcaseData()" class="c-modal-top__name">
              {{ this.advisorName() }}
            </strong>
            para os seus amigos que irão casar! 🎉
          </h6>
        </div>
        <div
          class="column is-12 is-4-desktop is-flex is-justify-content-center is-align-items-center"
        >
          <div
            class="c-base-modal__logo"
            v-if="hasShowcaseData()"
            :style="{ 'background-image': 'url(' + this.advisorLogo() + ')' }"
          ></div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <h6 class="c-modal__intro">
            Contratando uma assessoria de casamento, você:
          </h6>
        </div>
      </div>
      <div class="c-modal-feature columns">
        <div class="column is-12 is-4-desktop">
          <div class="box-rounded">
            <svg
              class="icon"
              viewBox="0 0 42 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="21" cy="21.418" r="21" fill="#F2F7FC" />
              <path
                d="M35.3691 30.1459C35.3691 30.6291 34.9774 31.0209 34.4941 31.0209C34.0109 31.0209 33.6191 30.6291 33.6191 30.1459C33.6191 29.6626 34.0109 29.2709 34.4941 29.2709C34.9774 29.2709 35.3691 29.6626 35.3691 30.1459Z"
                fill="#E583A2"
              />
              <path
                d="M33.6182 11.5106C33.6182 11.9939 33.2264 12.3856 32.7432 12.3856C32.2599 12.3856 31.8682 11.9939 31.8682 11.5106C31.8682 11.0274 32.2599 10.6356 32.7432 10.6356C33.2264 10.6356 33.6182 11.0274 33.6182 11.5106Z"
                fill="#E583A2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.42519 14.9631C7.25434 14.7922 6.97733 14.7922 6.80647 14.9631L6.03235 15.7372L5.25827 14.9631C5.08741 14.7923 4.8104 14.7923 4.63955 14.9631C4.46869 15.134 4.46869 15.411 4.63955 15.5819L5.41363 16.3559L4.63937 17.1302C4.46852 17.3011 4.46852 17.5781 4.63937 17.7489C4.81023 17.9198 5.08724 17.9198 5.25809 17.7489L6.03235 16.9747L6.80575 17.7481C6.97661 17.9189 7.25362 17.9189 7.42447 17.7481C7.59532 17.5772 7.59532 17.3002 7.42447 17.1293L6.65107 16.3559L7.42519 15.5818C7.59605 15.411 7.59605 15.134 7.42519 14.9631Z"
                fill="#E583A2"
              />
              <ellipse
                cx="21.1133"
                cy="21.8609"
                rx="7.46531"
                ry="7.40957"
                fill="#E583A2"
              />
              <path
                d="M20.9956 12.2033C15.8675 12.2033 11.7056 16.3652 11.7056 21.4934C11.7056 26.6215 15.8675 30.7834 20.9956 30.7834C26.1237 30.7834 30.2857 26.6215 30.2857 21.4934C30.2857 16.3652 26.1237 12.2033 20.9956 12.2033ZM20.9956 15.9193C22.7886 15.9193 24.2471 17.3779 24.2471 19.1708C24.2471 20.9638 22.7886 22.4224 20.9956 22.4224C19.2026 22.4224 17.7441 20.9638 17.7441 19.1708C17.7441 17.3779 19.2026 15.9193 20.9956 15.9193ZM20.9956 28.9254C19.1097 28.9254 16.8801 28.1636 15.2915 26.2499C16.8615 25.0236 18.8403 24.2804 20.9956 24.2804C23.1509 24.2804 25.1297 25.0236 26.6997 26.2499C25.1111 28.1636 22.8815 28.9254 20.9956 28.9254Z"
                fill="#F0E0EA"
              />
            </svg>
            <p class="text">
              Garante um atendimento 100% personalizado e único
            </p>
          </div>
        </div>
        <div class="column is-12 is-4-desktop">
          <div class="box-rounded">
            <svg
              class="icon"
              viewBox="0 0 42 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="21" cy="21.418" r="21" fill="#F2F7FC" />
              <path
                d="M33.6182 11.5101C33.6182 11.9933 33.2264 12.3851 32.7432 12.3851C32.2599 12.3851 31.8682 11.9933 31.8682 11.5101C31.8682 11.0268 32.2599 10.6351 32.7432 10.6351C33.2264 10.6351 33.6182 11.0268 33.6182 11.5101Z"
                fill="#E583A2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.42519 14.9624C7.25434 14.7915 6.97733 14.7915 6.80647 14.9624L6.03235 15.7365L5.25827 14.9624C5.08741 14.7916 4.8104 14.7916 4.63955 14.9624C4.46869 15.1333 4.46869 15.4103 4.63955 15.5811L5.41363 16.3552L4.63937 17.1295C4.46852 17.3003 4.46852 17.5773 4.63937 17.7482C4.81023 17.919 5.08724 17.919 5.25809 17.7482L6.03235 16.9739L6.80575 17.7473C6.97661 17.9182 7.25362 17.9182 7.42447 17.7473C7.59532 17.5765 7.59532 17.2995 7.42447 17.1286L6.65107 16.3552L7.42519 15.5811C7.59605 15.4102 7.59605 15.1332 7.42519 14.9624Z"
                fill="#E583A2"
              />
              <rect
                x="15.2407"
                y="17.2291"
                width="11.5006"
                height="8.46971"
                fill="#E583A2"
              />
              <path
                d="M30.9624 21.4206L28.7528 18.8941L29.0607 15.5526L25.7916 14.81L24.0801 11.9122L21.0012 13.2343L17.9223 11.9122L16.2108 14.801L12.9417 15.5345L13.2496 18.885L11.04 21.4206L13.2496 23.9471L12.9417 27.2977L16.2108 28.0403L17.9223 30.929L21.0012 29.5978L24.0801 30.9199L25.7916 28.0312L29.0607 27.2886L28.7528 23.9471L30.9624 21.4206ZM19.2716 25.6949L15.8305 22.2447L17.1707 20.9044L19.2716 23.0144L24.5691 17.6988L25.9093 19.039L19.2716 25.6949Z"
                fill="#F0E0EA"
              />
            </svg>
            <p class="text">
              Tem tranquilidade em todas as decisões do casamento
            </p>
          </div>
        </div>
        <div class="column is-12 is-4-desktop">
          <div class="box-rounded">
            <svg
              class="icon"
              viewBox="0 0 42 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="21" cy="21.418" r="21" fill="#F2F7FC" />
              <path
                d="M33.6182 11.5101C33.6182 11.9933 33.2264 12.3851 32.7432 12.3851C32.2599 12.3851 31.8682 11.9933 31.8682 11.5101C31.8682 11.0268 32.2599 10.6351 32.7432 10.6351C33.2264 10.6351 33.6182 11.0268 33.6182 11.5101Z"
                fill="#E583A2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.42519 14.9624C7.25434 14.7915 6.97733 14.7915 6.80647 14.9624L6.03235 15.7365L5.25827 14.9624C5.08741 14.7916 4.8104 14.7916 4.63955 14.9624C4.46869 15.1333 4.46869 15.4103 4.63955 15.5811L5.41363 16.3552L4.63937 17.1295C4.46852 17.3003 4.46852 17.5773 4.63937 17.7482C4.81023 17.919 5.08724 17.919 5.25809 17.7482L6.03235 16.9739L6.80575 17.7473C6.97661 17.9182 7.25362 17.9182 7.42447 17.7473C7.59532 17.5765 7.59532 17.2995 7.42447 17.1286L6.65107 16.3552L7.42519 15.5811C7.59605 15.4102 7.59605 15.1332 7.42519 14.9624Z"
                fill="#E583A2"
              />
              <circle cx="20.9945" cy="22.11" r="9.07214" fill="#F0E0EA" />
              <g clip-path="url(#clip0_1647_3478)">
                <path
                  d="M24.2832 20.6415L24.8705 19.2956L26.1626 18.6838L24.8705 18.0721L24.2832 16.7262L23.6959 18.0721L22.4039 18.6838L23.6959 19.2956L24.2832 20.6415ZM20.7595 20.8862L19.5849 18.1944L18.4103 20.8862L15.8262 22.1097L18.4103 23.3333L19.5849 26.025L20.7595 23.3333L23.3436 22.1097L20.7595 20.8862ZM24.2832 23.578L23.6959 24.9239L22.4039 25.5356L23.6959 26.1474L24.2832 27.4933L24.8705 26.1474L26.1626 25.5356L24.8705 24.9239L24.2832 23.578Z"
                  fill="#E583A2"
                />
              </g>
              <defs>
                <clipPath id="clip0_1647_3478">
                  <rect
                    width="11.2761"
                    height="11.7459"
                    fill="white"
                    transform="translate(15.3564 16.2368)"
                  />
                </clipPath>
              </defs>
            </svg>
            <p class="text">
              Proporciona uma memória inesquecível aos convidados
            </p>
          </div>
        </div>
      </div>
      <div class="buttons columns">
        <div class="column is-12 is-6-desktop">
          <button class="copy-link button" @click="copyToClipboard()">
            <svg
              viewBox="0 0 19 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.4736 7.35797C18.4632 7.2661 18.4431 7.1756 18.4136 7.08797V6.99797C18.3656 6.89515 18.3014 6.80063 18.2236 6.71797L12.2236 0.717969C12.141 0.640185 12.0465 0.57605 11.9436 0.527969C11.9138 0.523729 11.8835 0.523729 11.8536 0.527969C11.752 0.46971 11.6399 0.432313 11.5236 0.417969H7.47363C6.67798 0.417969 5.91492 0.734039 5.35231 1.29665C4.7897 1.85926 4.47363 2.62232 4.47363 3.41797V4.41797H3.47363C2.67798 4.41797 1.91492 4.73404 1.35231 5.29665C0.789703 5.85926 0.473633 6.62232 0.473633 7.41797V17.418C0.473633 18.2136 0.789703 18.9767 1.35231 19.5393C1.91492 20.1019 2.67798 20.418 3.47363 20.418H11.4736C12.2693 20.418 13.0323 20.1019 13.595 19.5393C14.1576 18.9767 14.4736 18.2136 14.4736 17.418V16.418H15.4736C16.2693 16.418 17.0323 16.1019 17.595 15.5393C18.1576 14.9767 18.4736 14.2136 18.4736 13.418V7.41797C18.4736 7.41797 18.4736 7.41797 18.4736 7.35797ZM12.4736 3.82797L15.0636 6.41797H13.4736C13.2084 6.41797 12.9541 6.31261 12.7665 6.12508C12.579 5.93754 12.4736 5.68319 12.4736 5.41797V3.82797ZM12.4736 17.418C12.4736 17.6832 12.3683 17.9375 12.1807 18.1251C11.9932 18.3126 11.7388 18.418 11.4736 18.418H3.47363C3.20842 18.418 2.95406 18.3126 2.76653 18.1251C2.57899 17.9375 2.47363 17.6832 2.47363 17.418V7.41797C2.47363 7.15275 2.57899 6.8984 2.76653 6.71086C2.95406 6.52333 3.20842 6.41797 3.47363 6.41797H4.47363V13.418C4.47363 14.2136 4.7897 14.9767 5.35231 15.5393C5.91492 16.1019 6.67798 16.418 7.47363 16.418H12.4736V17.418ZM16.4736 13.418C16.4736 13.6832 16.3683 13.9375 16.1807 14.1251C15.9932 14.3126 15.7388 14.418 15.4736 14.418H7.47363C7.20842 14.418 6.95406 14.3126 6.76653 14.1251C6.57899 13.9375 6.47363 13.6832 6.47363 13.418V3.41797C6.47363 3.15275 6.57899 2.8984 6.76653 2.71086C6.95406 2.52333 7.20842 2.41797 7.47363 2.41797H10.4736V5.41797C10.4736 6.21362 10.7897 6.97668 11.3523 7.53929C11.9149 8.1019 12.678 8.41797 13.4736 8.41797H16.4736V13.418Z"
                fill="#657787"
              />
            </svg>

            <span class="copy-link-text">Copiar Link</span>
          </button>
        </div>
        <div class="column is-12 is-6-desktop">
          <a
            class="button c-base-modal__button--whatsapp"
            @click="close"
            :href="whatsAppLink"
            target="_blank"
            title="Enviar no Whatsapp"
            v-if="modalOpened"
          >
            <svg
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.4983 14.2258L10.5144 14.2417L10.5319 14.2562C11.2962 14.8894 12.1793 15.3904 13.0539 15.7641C13.2218 15.8453 13.4424 15.9129 13.6791 15.8793C13.9264 15.8442 14.1343 15.706 14.2685 15.491C14.4076 15.3405 14.5794 15.1128 14.7258 14.9186L14.7464 14.8914C14.9391 14.6359 15.0934 14.4337 15.182 14.3456C15.2128 14.3149 15.2339 14.3017 15.2438 14.2964C15.2487 14.2939 15.2516 14.2928 15.2528 14.2925C15.2576 14.2925 15.2807 14.2942 15.3303 14.3189C15.457 14.3819 15.9079 14.591 16.3485 14.7954L16.3673 14.8041C16.8249 15.0164 17.2673 15.2217 17.3799 15.2777L17.644 15.4089C17.6892 15.7093 17.6604 15.9849 17.5307 16.2563C17.0965 16.8918 16.4902 17.3593 15.8443 17.451L15.8443 17.4509L15.8328 17.4528C15.154 17.5653 14.6542 17.554 14.1703 17.3616L14.1278 17.3447L14.083 17.3358C13.6706 17.2538 13.3355 17.1144 12.9147 16.9393C12.785 16.8853 12.6471 16.828 12.4964 16.7679C10.5473 15.8529 8.92805 14.3631 7.64513 12.5081L7.63926 12.4996L7.63304 12.4914C6.97836 11.6236 6.64373 10.644 6.52836 9.64903C6.53504 8.8439 6.83728 8.13897 7.46583 7.51414C7.48453 7.49556 7.56415 7.43181 7.67153 7.37251C7.72169 7.34482 7.76718 7.32414 7.80379 7.31135C7.82725 7.30316 7.8401 7.30065 7.84351 7.29999H7.84378H7.8452H7.84661H7.84802H7.84944H7.85085H7.85226H7.85367H7.85509H7.8565H7.85791H7.85932H7.86073H7.86215H7.86356H7.86497H7.86638H7.86779H7.8692H7.87062H7.87203H7.87344H7.87485H7.87626H7.87767H7.87908H7.88049H7.8819H7.88331H7.88472H7.88613H7.88754H7.88895H7.89036H7.89177H7.89318H7.89459H7.89599H7.8974H7.89881H7.90022H7.90162H7.90303H7.90444H7.90585H7.90725H7.90866H7.91006H7.91147H7.91287H7.91428H7.91568H7.91709H7.91849H7.9199H7.9213H7.9227H7.9241H7.92551H7.92691H7.92831H7.92971H7.93111H7.93251H7.93391H7.93531H7.93671H7.93811H7.93951H7.94091H7.94231H7.9437H7.9451H7.9465H7.94789H7.94929H7.95069H7.95208H7.95347H7.95487H7.95626H7.95766H7.95905H7.96044H7.96183H7.96322H7.96461H7.966H7.96739H7.96878H7.97017H7.97156H7.97295H7.97434H7.97572H7.97711H7.97849H7.97988H7.98126H7.98265H7.98403H7.98541H7.9868H7.98818H7.98956H7.99094H7.99232H7.9937H7.99508H7.99646H7.99783H7.99921H8.00059H8.00196H8.00334H8.00471H8.00609H8.00746H8.00883H8.0102H8.01157H8.01295H8.01431H8.01568H8.01705H8.01842H8.01979H8.02115H8.02252H8.02388H8.02525H8.02661H8.02797H8.02934H8.0307H8.03206H8.03342H8.03478H8.03613H8.03749H8.03885H8.0402H8.04156H8.04291H8.04427H8.04562H8.04697H8.04832H8.04967H8.05102H8.05237H8.05372H8.05507H8.05641H8.05776H8.0591H8.06044H8.06179H8.06313H8.06447H8.06581H8.06715H8.06849H8.06982H8.07116H8.0725H8.07383H8.07516H8.0765H8.07783H8.07916H8.08049H8.08182H8.08315H8.08447H8.0858H8.08712H8.08845H8.08977H8.09109H8.09241H8.09373H8.09505H8.09637H8.09769H8.099H8.10032H8.10163H8.10295H8.10426H8.10557H8.10688H8.10819H8.1095H8.1108H8.11211H8.11341H8.11472H8.11602H8.11732H8.11862H8.11992H8.12122H8.12251H8.12381H8.1251H8.1264H8.12769H8.12898H8.13027H8.13156H8.13285H8.13413H8.13542H8.1367H8.13799H8.13927H8.14055H8.14183H8.14311H8.14438H8.14566H8.14693H8.14821H8.14948H8.15075H8.15202H8.15329H8.15456H8.15582H8.15709H8.15835H8.15961H8.16087H8.16213H8.16339H8.16465H8.1659H8.16716H8.16841H8.16966H8.17091H8.17216H8.17341H8.17466H8.1759H8.17715H8.17839H8.17963H8.18087H8.18211H8.18334H8.18458H8.18581H8.18705H8.18828H8.18951H8.19074H8.19196H8.19319H8.19441H8.19564H8.19686H8.19808H8.1993H8.20051H8.20173H8.20294H8.20416H8.20537H8.20658H8.20779H8.20899H8.2102H8.2114H8.21261H8.21381H8.215H8.2162H8.2174H8.21859H8.21979H8.22098H8.22217H8.22336H8.22454H8.22573H8.22691H8.2281H8.22928H8.23046H8.23163H8.23281H8.23398H8.23516H8.23633H8.2375H8.23867H8.23983H8.241H8.24216H8.24332H8.24448H8.24564H8.24679H8.24795H8.2491H8.25025H8.2514H8.25255H8.2537H8.25484H8.25599H8.25713H8.25827H8.2594H8.26054H8.26167H8.26281H8.26394H8.26507H8.26619H8.26732H8.26844H8.26957H8.27069H8.2718H8.27292H8.27404H8.27515H8.27626H8.27737H8.27848H8.27958H8.28069H8.28179H8.28289H8.28399H8.28509H8.28618H8.28727H8.28837H8.28945H8.29054H8.29163H8.29271H8.29379H8.29487H8.29595H8.29703H8.2981H8.29917H8.30024H8.30131H8.30238H8.30344H8.30451H8.30557H8.30663H8.30768H8.30874H8.30979H8.31084H8.31189H8.31294H8.31398H8.31502H8.31607H8.3171H8.31814H8.31918H8.32021H8.32124H8.32227H8.3233H8.32432H8.32534H8.32636H8.32738H8.3284H8.32941H8.33043H8.33144H8.33244H8.33345H8.33445H8.33546H8.33646H8.33745H8.33845H8.33944H8.34044H8.34142H8.34241H8.3434H8.34438H8.34536H8.34634H8.34731H8.34829H8.34926H8.35023H8.3512H8.35216H8.35313H8.35409H8.35505H8.356H8.35696H8.35791H8.35886H8.35981H8.36075H8.36169H8.36264H8.36357H8.36451H8.36544H8.36638H8.36731H8.36823H8.36916H8.37008H8.371H8.37192H8.37284H8.37375H8.37466H8.37557H8.37647H8.37738H8.37828H8.37918H8.38008H8.38097H8.38186H8.38275H8.38364H8.38453H8.38541H8.38629H8.38717H8.38804H8.38892H8.38979H8.39066H8.39152H8.39239H8.39325H8.3941H8.39496H8.39581H8.39667H8.39752H8.39836H8.39921H8.40005H8.40089H8.40172H8.40256H8.40339H8.40422H8.40504H8.40587H8.40669H8.40751H8.40832H8.40914H8.40995H8.41076H8.41156H8.41237H8.41317H8.41397H8.41476H8.41556H8.41635H8.41713H8.41792H8.4187H8.41948H8.42026H8.42104H8.42181H8.42258H8.42334H8.42411H8.42487H8.42563H8.42639H8.42714H8.42789H8.42864H8.42939H8.43013H8.43087H8.43161H8.43234H8.43308H8.43381H8.43453H8.43526H8.43598H8.4367H8.43741H8.43813H8.43884H8.43954C8.4438 7.29999 8.44782 7.3 8.4516 7.30001C8.45479 7.30765 8.45823 7.31638 8.46187 7.3263C8.48905 7.40029 8.52023 7.5206 8.54745 7.71007L8.55602 7.7697L8.57851 7.82559C8.70056 8.1289 8.91339 8.64271 9.1115 9.09717C9.21034 9.32391 9.30731 9.54002 9.38839 9.70909C9.42868 9.79308 9.46751 9.87066 9.5023 9.9341C9.51814 9.963 9.53538 9.99307 9.55333 10.0215L9.50689 10.0677V10.2407C9.50244 10.2529 9.49524 10.27 9.48486 10.2907C9.47188 10.3165 9.45687 10.3419 9.44197 10.3636C9.44182 10.3638 9.44168 10.364 9.44153 10.3642C9.28607 10.4615 9.17445 10.5802 9.09625 10.6735C9.0593 10.7176 9.02381 10.7636 8.99764 10.7975C8.99158 10.8054 8.98601 10.8126 8.98105 10.819C8.94873 10.8605 8.93599 10.8749 8.931 10.8798C8.73193 11.0777 8.45832 11.5456 8.71626 12.0584L8.73028 12.0863L8.74767 12.1122C9.24969 12.8607 9.87398 13.6051 10.4983 14.2258ZM2.16987 18.4387L2.22501 18.239L2.12277 18.0588C-0.420828 13.5765 0.274771 7.95096 3.96945 4.27819C8.47487 -0.200519 15.7519 -0.202104 20.2593 4.27343C22.3491 6.46857 23.6072 9.33603 23.4928 12.2938L23.4924 12.3034V12.3131C23.4924 18.6259 18.4142 23.6783 12.0565 23.6783C10.2115 23.6783 8.36265 23.22 6.62415 22.2983L6.45172 22.2069L6.26295 22.2565L0.713183 23.7138L2.16987 18.4387ZM6.71656 21.3591L6.73612 21.3721L6.75681 21.3831C8.38769 22.2561 10.156 22.7607 12.0565 22.7607C14.0909 22.7607 15.9886 22.1285 17.6223 21.1291C22.5703 18.1023 23.9547 11.6767 20.9212 6.77651L20.9212 6.77649L20.9181 6.77156C17.8838 1.99581 11.5503 0.34969 6.6035 3.50192C1.67513 6.64241 0.153515 12.9358 3.18888 17.9647L3.19504 17.9749L3.20169 17.9848L3.3163 18.1558L2.41063 21.5319L2.18892 22.3584L3.0178 22.1457L6.54008 21.2421L6.71656 21.3591Z"
                fill="white"
                stroke="white"
              />
            </svg>
            Enviar no Whatsapp
          </a>
        </div>
      </div>
    </div>
  </base-modal-center>
</template>

<script>
import isMobileBrowser from '@/plugins/detect-mobile-browser'
import BaseModalCenter from '@/components/BaseModalCenter.vue'

export default {
  components: {
    BaseModalCenter,
  },

  data() {
    return {
      modalOpened: false,
      message: `Olá esse é o assessor do meu casamento! Tenho certeza que ele vai te ajudar no seu grande dia também!\n`,
    }
  },

  computed: {
    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    advisorInfo() {
      return `${this.advisorName()}\n${this.advisorUrl()}`
    },

    whatsAppLink() {
      let linkToShare = `${this.message}\n${this.advisorInfo}`

      let linkWP = isMobileBrowser()
        ? 'whatsapp://'
        : 'https://web.whatsapp.com/'
      linkWP += 'send?text='

      return linkWP + window.encodeURIComponent(linkToShare)
    },
  },

  methods: {
    open() {
      this.$refs.shareMyAdvisorModal.open()
      this.modalOpened = true
    },

    close() {
      this.$refs.shareMyAdvisorModal.close()
      this.modalOpened = false
    },

    copyToClipboard() {
      this.$copyText(this.advisorUrl())
      document.getElementsByClassName('copy-link-text')[0].innerHTML =
        'Link copiado'
      document.getElementsByClassName('copy-link-text')[0].style.color =
        '#3DAFB0'
    },

    advisorName() {
      return this.wedSiteInfo.shared_menu.showcase_data.company_name
    },

    advisorUrl() {
      return this.wedSiteInfo.shared_menu.showcase_data.url
    },

    advisorLogo() {
      return this.wedSiteInfo.shared_menu.showcase_data.icon_url
    },

    hasShowcaseData() {
      return this.wedSiteInfo.shared_menu?.showcase_data ? true : false
    },
  },
}
</script>

<style lang="scss" scoped>
.c-modal {
  padding: 0.5rem;
  @media (min-width: $tablet) {
    padding: 2rem 1rem;
  }
  .columns {
    margin-bottom: 0.75rem;
    @media (min-width: $tablet) {
      margin-bottom: 2rem;
    }
    .column {
      @media (min-width: $tablet) {
        padding: 0.5rem;
      }
    }
  }
  .c-modal-top {
    background-color: $backgroundprimary;
    border-radius: 10px;
    font-size: 20px;
    padding: 1rem;

    @media (max-width: $tablet) {
      display: flex;
    }
    @media (min-width: $tablet) {
      display: flex;
      height: 128px;
    }
    .column {
      align-items: center;
      justify-content: center;
      display: flex;
      padding: 0 0.5rem;
    }
    .c-base-modal__logo {
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 100%;
      height: 100px;
      width: 100px;
    }
    .c-base-modal__title {
      color: $primary;
      font-size: 18px;
      @media (max-width: $tablet) {
        font-size: 20px;
      }
      @media (min-width: $tablet) {
        font-size: 20px;
        margin-bottom: 0;
      }
      .c-modal-top__name {
        color: $gray-7;
      }
    }
  }
  .c-modal__intro {
    font-size: 1.175rem;
    font-weight: 700;
    color: $gray-7;
  }
  .c-modal-feature {
    .box-rounded {
      border-radius: 5px;
      border: 1px solid $gray-3;
      padding: 12px;
      height: 100%;
      font-size: 14px;
      @media (max-width: $tablet) {
        display: flex;
        text-align: left;
      }
      @media (min-width: $tablet) {
        padding-bottom: 24px;
      }
      .icon {
        width: 42px;
        height: 42px;
        @media (min-width: $tablet) {
          margin-right: 0.5rem;
        }
        @media (min-width: $tablet) {
          margin-bottom: 1rem;
        }
      }
    }
  }
  .buttons {
    font-size: 1rem;
    .button {
      display: flex;
      justify-content: center;
      max-width: 100%;
      width: 100%;
      margin-bottom: 0;
      svg {
        height: 18px;
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
